import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router'

const Index = lazy(() => import('pages/platform/my/Index'))
const Course = lazy(() => import('pages/platform/my/Course'))
const Order = lazy(() => import('pages/platform/my/Order'))
const AddrSet = lazy(() => import('pages/platform/my/AddrSet'))
const UserInfo = lazy(() => import('pages/platform/my/UserInfo'))
const Setting = lazy(() => import('pages/platform/my/Setting'))
const Login = lazy(() => import('pages/platform/my/Login'))
const Verify = lazy(() => import('pages/platform/my/Verify'))
const Register = lazy(() => import('pages/platform/my/Register'))


const ActivityRoute = ({ match }) => {
  const rootUrl = match.url
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route exact path={`${rootUrl}/index`} component={(Index)} />
        <Route exact path={`${rootUrl}/course`} component={(Course)} />
        <Route exact path={`${rootUrl}/order`} component={(Order)} />
        <Route exact path={`${rootUrl}/addrSet`} component={(AddrSet)} />
        <Route exact path={`${rootUrl}/userInfo`} component={(UserInfo)} />
        <Route exact path={`${rootUrl}/setting`} component={(Setting)} />
        <Route exact path={`${rootUrl}/login`} component={(Login)} />
        <Route exact path={`${rootUrl}/verify/:id`} component={(Verify)} />
        <Route exact path={`${rootUrl}/register/:verifyType/:phoneNumber`} component={(Register)} />
      </Switch>
    </Suspense>
  )
}
export default ActivityRoute
